import type { Monaco } from './sqlMonacoTypes';

/**
 * LSP CompletionItemKind to Monaco CompletionItemKind mapping.
 * LSP and Monaco use the same numbering for most kinds.
 */
const LSP_TO_MONACO_KIND_MAP: Record<number, string> = {
  1: 'Text',
  2: 'Method',
  3: 'Function',
  4: 'Constructor',
  5: 'Field',
  6: 'Variable',
  7: 'Class',
  8: 'Interface',
  9: 'Module',
  10: 'Property',
  11: 'Unit',
  12: 'Value',
  13: 'Enum',
  14: 'Keyword',
  15: 'Snippet',
  16: 'Color',
  17: 'File',
  18: 'Reference',
  19: 'Folder',
  20: 'EnumMember',
  21: 'Constant',
  22: 'Struct',
  23: 'Event',
  24: 'Operator',
  25: 'TypeParameter'
};

/**
 * Convert LSP CompletionItemKind to Monaco CompletionItemKind.
 * @param monaco - Monaco editor instance
 * @param lspKind - LSP completion item kind number
 * @returns Monaco completion item kind number
 */
export function convertCompletionItemKind(monaco: Monaco, lspKind: number): number {
  if (!monaco) return 0;

  const CompletionItemKind = monaco.languages.CompletionItemKind;
  const kindName = LSP_TO_MONACO_KIND_MAP[lspKind] || 'Text';

  return (CompletionItemKind as unknown as Record<string, number>)[kindName] ?? CompletionItemKind.Text;
}
